import React from "react";

// State-aware hover preview (set via custom modifiers in datePicker). Inline
// styles are used rather than Tailwind classes because the build doesn't emit
// the light "ocean" tints reliably.
//  hoverFirst - nothing selected yet, this would be the departure
//  hoverRange - days between the chosen departure and the cursor
//  hoverEnd   - the cursor day, i.e. the would-be return
//  hoverReset - both dates already chosen, clicking starts a fresh departure
const OCEAN_100 = "#e0f2fe";
const OCEAN_200 = "#bae6fd";
const EMP = "#009DD6";
const hoverStyle = (modifiers) => {
  if (modifiers.hoverFirst) return { backgroundColor: OCEAN_100, borderRadius: "9999px" };
  if (modifiers.hoverEnd) return { backgroundColor: OCEAN_200, borderRadius: "9999px" };
  if (modifiers.hoverRange) return { backgroundColor: OCEAN_100 };
  if (modifiers.hoverReset) return { boxShadow: `inset 0 0 0 2px ${EMP}`, borderRadius: "9999px" };
  return undefined;
};

const CustomDayButton = (props, price, displayPriceIndicator) => {
  const { day, modifiers, ...buttonProps } = props;

  const ref = React.useRef(null);
  React.useEffect(() => {
    if (modifiers.focused) ref.current?.focus();
  }, [modifiers.focused]);

  const style = hoverStyle(modifiers);

  if (price?.pricingStatus == "low" && displayPriceIndicator) {
    return(
    <button ref={ref} {...buttonProps} style={style} className={buttonProps.className + " flex-col"}>
      <div>
        {buttonProps.children}
      </div>
      <div className="h-2 text-center">
        <div className="mx-auto w-2 h-2 bg-green-300 rounded-full"></div>
      </div>
    </button>);
  } else {
     return(
    <button ref={ref} {...buttonProps} style={style} className={buttonProps.className + " flex-col"}>
      <div>
        {buttonProps.children}
      </div>
      <div className="h-2 text-center">
       </div>
    </button>);
  }

}
export default CustomDayButton;
